import SelectTestItem from '../selectTestItem';

type TSelectTestItemsProps = {
  tests: ILabTest[];
  setSelectableLabTests: React.Dispatch<React.SetStateAction<ILabTest[]>>;
};

const SelectTestItems = ({
  tests,
  setSelectableLabTests,
}: TSelectTestItemsProps) => {
  return (
    <>
      {tests.map(item => (
        <SelectTestItem
          key={item.guid}
          test={item}
          setSelectableLabTests={setSelectableLabTests}
        />
      ))}
    </>
  );
};

export default SelectTestItems;
